import { getReportSettingByKey } from "../utils/reportFunctions";

export const addHeaderToArray = (
  text,
  array,
  depth,
  section,
  savedTemplate,
  templateApplied,
  headerType,
) => {
  if (depth === 3) {
    const ids = getReportSettingByKey("ids");

    if (ids.length <= 1) {
      return;
    }
  }

  const header = {
    text,
    label: `header-${depth}-${section}`,
    gridBoxType: "header",
    visible: true,
    section,
    depth,
    headerType,
  };

  if (savedTemplate?.length && !templateApplied) {
    if (savedTemplate.find((item) => item.i === header.label)) {
      array.push(header);
    }
  } else {
    array.push(header);
  }
};
